export default __webpack_public_path__ + "static/media/dude.92265d48.jpg";